import React from "react";
import { setDisplayName } from "recompose";
import MediaQuery from "react-responsive";

export default setDisplayName("VisibleOn")(({ children, width }) => (
  <MediaQuery maxWidth={width}>{children}</MediaQuery>
));
